import { takeLatest } from 'redux-saga/effects';

import { simpleRequest } from 'modules/app/utils';
import * as types from 'modules/tireBrands/actionTypes';

export default function* tireBrandsSagas() {
  yield takeLatest(types.FETCH_TIRE_BRAND_REQUEST, simpleRequest);
}
